import {useContext, useEffect, useMemo, useState} from "react";
import {FormContext} from "wsc-react-custom-form";

export function getFinalName(name) {
    if (Array.isArray(name)) return name;
    const names = name.split('.');
    if (names.length === 1) {
        return names[0];
    } else {
        return names;
    }
}
export function getFinalValue(nameArray, formData) {
    if (Array.isArray(nameArray)) {
        return nameArray.reduce((acc, item) => {
            if (acc?.hasOwnProperty(item)) {
                return acc[item];
            }
            return undefined;
        }, formData);
    } else {
        return formData[nameArray];
    }
}

export function getFinalNameAndValue(name, formData) {
    const finalName = getFinalName(name);
    const finalValue = getFinalValue(finalName, formData);
    return {
        name: finalName,
        value: finalValue,
    }
}

export default function useNameOfForm(name) {
    const { form, formdata } = useContext(FormContext);
    const [value, setValue] = useState<any>(undefined);
    // name使用点号分割的：转换为数组
    const nameArray = useMemo(()=> getFinalName(name), [name]);
    // 获取级联属性
    useEffect(()=> {
        const value = getFinalValue(nameArray, formdata);
        setValue(value);
        form.setFieldValue(nameArray, value);
    }, [form, formdata, nameArray]);

    return { form, formdata, nameArray, value };
}